module.exports = __webpack_public_path__ + "static/media/cbn.53604431.jpg";